import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2293474b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=2293474b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293474b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2293474b')) {
      api.createRecord('2293474b', component.options)
    } else {
      api.reload('2293474b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2293474b&scoped=true&", function () {
      api.rerender('2293474b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O3w47xxe97Od/JS/comp/SearchFilterTokens.vue"
export default component.exports